import React, { useEffect, useMemo, useState } from "react";
import { LargeButton, OverlayLoader, PageTitle } from "components/core";
import { useLocation, useNavigate } from "react-router";
import { DisplayName } from "utlis/utils";
import http from "services/httpService";
import routes from "components/routes";
import CustomTabs from "pages/GradeSetup/CustomTabs";

const GradeEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [attributes, setAttributes] = useState([]);
  const [grades, setGrades] = useState([{}]);
  const [loading, setLoading] = useState(true);
  const [defaultIndex, setDefaultIndex] = useState(0);

  let selectedValues = localStorage.getItem("eb_selected_values");
  if (selectedValues) {
    selectedValues = JSON.parse(selectedValues);
  }
  const userplanId = localStorage.getItem("eb_current_plan");

  const getGradeSelectables = async () => {
    const { data } = await http.get("/business/get_grade_setup_selectables/", {
      params: {
        userplan_id: userplanId,
      },
    });
    if (data) setAttributes(data);
  };

  const allowGradeAddition = useMemo(() => {
    if (!selectedValues) return false;
    return selectedValues.userplans_data[userplanId]?.flat_or_graded !== "FLAT";
  }, [selectedValues]);

  const getGradeSelected = async () => {
    try {
      const { data } = await http.get("business/userplans_data_selected/");
      localStorage.setItem("eb_selected_values", JSON.stringify(data));
      const gradesData = data.userplans_data[userplanId].userplan_grades_data;
      if (gradesData.length > 0) {
        setGrades(gradesData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const doesGradesExist = useMemo(() => {
    if (!selectedValues) return false;
    const currentPlan =
      selectedValues.userplans_data[userplanId]?.userplan_grades_data.length >
      0;
    if (currentPlan) return true;
    return false;
  });

  const isPostIssuance = useMemo(() => {
    if (location?.state?.postIssuance) return true;
    return false;
  }, [location]);

  useEffect(() => {
    (async function () {
      const { state } = location;
      if (state) {
        setDefaultIndex(state.mappingId);
      }
      if (userplanId) {
        setLoading(true);
        await getGradeSelected();
        await getGradeSelectables();
        setTimeout(() => {
          setLoading(false);
        }, 400);
      }
    })();
  }, []);

  const handleGradeAddition = (value) => {
    setGrades((prev) => [...prev, value]);
  };
  const handleGradeDeletion = (index) => {
    // setGrades((prev) => prev - 1);
  };

  const isFlat = useMemo(() => {
    if (!selectedValues) return false;
    return selectedValues.userplans_data[userplanId]?.flat_or_graded === "FLAT";
  }, [selectedValues]);

  const redirectToGradeSummary = () => {
    // navigate(-1)
    navigate("/grade-setup/exclusion")
  };
  return loading ? (
    <OverlayLoader />
  ) : (
    <>
      <section
        style={{
          width: "930px",
        }}
      >
        <div
          style={{
            marginTop: "36px",
          }}
        >
          <CustomTabs
            handleGradeDeletion={handleGradeDeletion}
            isPostIssuance={isPostIssuance}
            grades={grades}
            attributes={attributes}
            allowGradeAddition={allowGradeAddition}
            handleGradeAddition={handleGradeAddition}
            isFlat={isFlat}
            defaultIndex={defaultIndex}
          />
        </div>
        <div
          style={{
            marginTop: "5rem",
          }}
        >
          <LargeButton
            disabled={!doesGradesExist}
            label="Submit"
            style={{
              marginTop: "8rem",
              opacity: doesGradesExist ? "1" : "0.5",
            }}
            onClick={redirectToGradeSummary}
          />
        </div>
      </section>
    </>
  );
};

export default GradeEdit;
